/**
 * @author Hiroki Moto
 * @description https://marvelapp.com/4g4b5dg/screen/58400387
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import { connect } from 'react-redux';
import { Tabs, Tab } from 'react-bootstrap';
import { isNil, isEmpty, type as RamdaType, propEq, find } from 'ramda';
import originalMoment from 'moment';
import { extendMoment } from 'moment-range';
import { toast } from 'react-toastify';
import queryString from 'query-string';
import DatePicker from '@components/@core/DatePicker';
import ErrorBoundary from '@components/@core/ErrorBoundary';
import Filter from '@components/@core/Filter';
import Pagination from '@components/@core/Pagination';
import EditDropdown from '@components/EditDropdown';
import { AppActions, DevelopActions, ManageActions } from '~/actions';
import { exportCsv } from '~/services/util-excel';
import EmployeesReport from './EmployeesReport';
import CertReport from './CertReport';
import { CertificationPdf } from './CertificationPdf';
import withNavigate from '~/hocs/withNavigate';
const moment = extendMoment(originalMoment);

class Certifications extends Component {
    constructor(props) {
        super(props);

        const queries = queryString.parse(props.location?.search || '');
        const dateStart = queries?.date_start || moment().startOf('month').format('YYYY-MM-DD');
        const dateEnd = queries?.date_end || moment().endOf('month').format('YYYY-MM-DD');
        const company = props.company[0] < 0 ? props.companies[0] : find(propEq('id', props.company[0]), props.companies);
        const page = Number(queries?.page) || 1;
        const per = Number(queries?.per_page) || 25;
        const activeTab = queries?.active || 'employees';

        this.state = { company, users: null, page, per, dateStart, dateEnd, activeTab };
    }

    componentDidMount() {
        const { activeTab, company, dateStart, dateEnd } = this.state;
        this.handleCertifications(activeTab, company.id, null, 1, 25, dateStart, dateEnd);
    }

    handleCertifications = (type, company_id, user_id, page, per_page, date_start, date_end) => {
        this.props.getCertifications(type, {
            company_id,
            user_id,
            page,
            per_page,
            date_start,
            date_end,
        });
    };

    handleDate = (e) => {
        const { activeTab, company, users, page, per } = this.state;
        const dateStart = moment(e.start).format('YYYY-MM-DD');
        const dateEnd = moment(e.end).format('YYYY-MM-DD');
        this.handleCertifications(activeTab, company?.id, users, page, per, dateStart, dateEnd);
        this.setState({ dateStart, dateEnd });
    };

    handleFilter = (type, e) => {
        const { activeTab, company, dateStart, dateEnd } = this.state;
        if (type === 'company') {
            if (e.length < 1 || e[0].id < 0) return;
            this.handleCertifications(activeTab, e[0].id, null, 1, 25, dateStart, dateEnd);
            this.setState({ company: e[0] });
        } else if (type === 'employee') {
            if (e.length === 0) {
                this.handleCertifications(activeTab, company?.id, null, 1, 25, dateStart, dateEnd);
                this.setState({ users: null });
            } else {
                const userIds = e.map((item) => item.id);
                this.handleCertifications(activeTab, company?.id || e[0].company_id, userIds, 1, 25, dateStart, dateEnd);
                this.setState({ users: userIds });
            }
        }
    };

    handleSelectTab = (tab) => {
        const { activeTab, page, per, company, users, dateStart, dateEnd } = this.state;
        if (activeTab !== tab) {
            this.setState({ activeTab: tab });
            this.handleCertifications(tab, company?.id, users, page, per, dateStart, dateEnd);
            this.props.navigate({ search: `?active=${tab}` });
        }
    };

    handlePage = (page) => {
        const { activeTab, company, users, per, dateStart, dateEnd } = this.state;
        this.handleCertifications(activeTab, company?.id, users, page, per, dateStart, dateEnd);
        this.setState({ page });
    };

    handlePer = (per) => {
        const { activeTab, company, users, dateStart, dateEnd } = this.state;
        let page = this.state.page;
        if (per > 50) page = 1;
        this.handleCertifications(activeTab, company?.id, users, page, per, dateStart, dateEnd);
        this.setState({ per });
    };

    handleOpenCertification = (event, item, user, type) => {
        const { company, page, per, dateStart, dateEnd } = this.state;
        switch (event) {
            case 'view certification': {
                const data = RamdaType(item) === 'Array' ? item[0] : item;
                if (type === 'employees') {
                    if (isNil(data)) {
                        toast.warn('No Certification assigned to the user', {
                            position: toast.POSITION.TOP_RIGHT,
                        });
                    } else {
                        this.props.getProgramDetail(data, 'certifications', {
                            pathname: `/hcm/report-certifications/${data.user_id}/${data.id}/view`,
                            state: { dateStart, dateEnd, page, per },
                        });
                    }
                } else {
                    this.props.getProgramDetail(data, 'certifications', `/library/programs/certifications/${data.id}/view`);
                }

                break;
            }
            case 'edit certification':
                this.props.toggleModal({
                    type: 'Advanced Edit',
                    data: {
                        before: {
                            programs: item,
                            userId: user.id,
                            after: {
                                type: 'FETCHCERTIFICATIONSREPORT_REQUEST',
                                target: type,
                                payload: {
                                    company_id: company?.id,
                                    page,
                                    per_page: per,
                                    date_start: dateStart,
                                    date_end: dateEnd,
                                },
                            },
                        },
                    },
                });
                break;

            case 'assign certification':
                this.props.toggleModal({
                    type: 'Assign Program',
                    data: {
                        before: {
                            modules: type === 'employees' ? [] : [item],
                            disabled: ['careers'],
                            assignees: user ? [user.id] : [],
                            levels: type === 'employees' ? null : item.data.levels,
                            companyId: company?.id,
                            after: {
                                type: 'FETCHCERTIFICATIONSREPORT_REQUEST',
                                target: type,
                                payload: {
                                    company_id: company?.id,
                                    page,
                                    per_page: per,
                                    date_start: dateStart,
                                    date_end: dateEnd,
                                },
                            },
                        },
                    },
                });
                break;
            case 'save actuals': {
                this.props.toggleModal({
                    type: 'Save Actuals',
                    data: {
                        before: {
                            user,
                            type: 'programs',
                            after: {
                                type: 'FETCHCERTIFICATIONSREPORT_REQUEST',
                                target: type,
                                payload: {
                                    company_id: company?.id,
                                    page,
                                    per_page: per,
                                    date_start: dateStart,
                                    date_end: dateEnd,
                                },
                            },
                        },
                    },
                });

                break;
            }
            default:
                break;
        }
    };

    handleExcelReport = () => {
        const { certificationsReport } = this.props;
        this.handlePer(certificationsReport.total);
        this.props.toggleModal({
            type: 'Confirm',
            data: {
                before: {
                    title: 'Confirm',
                    body: 'Would you like to download this reports data to excel?',
                },
            },
            callBack: {
                onYes: () => {
                    this.handleExcel();
                },
            },
        });
    };

    handleExcel = () => {
        const { activeTab } = this.state;
        const { certificationsReport } = this.props;
        const { users, programs } = certificationsReport;
        let data = [];
        let key = [];
        if (activeTab === 'employees') {
            users.forEach((user) => {
                const openCerts = user.stats.open_certifications.map(({ title }) => ({ title }));
                let openCertsTitle = [];
                openCerts.forEach((e) => {
                    openCertsTitle.push(e.title);
                });
                const completedCerts = user.stats.completed_certifications.map(({ title }) => ({ title }));
                let completedCertsTitle = [];
                completedCerts.forEach((e) => {
                    completedCertsTitle.push(e.title);
                });
                const employeeData = {
                    Employee: user.profile.first_name + user.profile.last_name,
                    Open: user.stats.open,
                    'Open Certifications': isEmpty(openCerts) ? 'Nothing open' : openCertsTitle.join(', '),
                    Completed: user.stats.completed,
                    'Completed Certifications': isEmpty(completedCerts) ? 'Nothing Completed' : completedCertsTitle.join(', '),
                };
                data.push(employeeData);
            });
            key = ['Employee', 'Open', 'Open Certifications', 'Completed', 'Completed Certifications'];
        } else {
            programs.map((program) => {
                const openEmployees = program?.stats?.open_employees.map((e) => {
                    const { profile } = e;
                    return { name: `${profile.first_name} ${profile.last_name}` };
                });
                const completedEmployees = program?.stats?.completed_employees.map((e) => {
                    const { profile } = e;
                    return { name: `${profile.first_name} ${profile.last_name}` };
                });
                let openEmployeesName = [];
                openEmployees.forEach((e) => {
                    openEmployeesName.push(e.name);
                });
                let completedEmployeesName = [];
                completedEmployees.forEach((e) => {
                    completedEmployeesName.push(e.name);
                });
                const certificationData = {
                    Certifications: program?.title,
                    Open: program?.stats?.open,
                    'Open Employees': isEmpty(openEmployees) ? 'No employee' : openEmployeesName.join(', '),
                    Completed: program?.stats?.completed,
                    'Completed Employees': isEmpty(completedEmployees) ? 'No employee' : completedEmployeesName.join(', '),
                };
                data.push(certificationData);
            });

            key = ['Certifications', 'Open', 'Open Employees', 'Completed', 'Completed Employees'];
        }
        exportCsv(data, key, `Certification-${activeTab}`, true);
        this.handlePer(25);
    };

    handleSelectMenu = (e) => {
        const { activeTab, dateStart, dateEnd } = this.state;
        const { certificationsReport, jobRoles } = this.props;
        const { users, programs } = certificationsReport;
        const date = moment.range(dateStart, dateEnd);

        switch (e) {
            case 'print':
                CertificationPdf({ users, programs, jobRoles, date, tab: activeTab });
                break;
            case 'export':
                this.handleExcelReport();
                break;
            default:
                break;
        }
    };

    render() {
        const { activeTab, dateStart, dateEnd, page, per } = this.state;
        const { userRole, certificationsReport } = this.props;
        const { last_page, users, programs } = certificationsReport;
        const title = activeTab === 'employees' ? 'Company Certification Report' : 'Certifications';
        const date = moment.range(dateStart, dateEnd);

        const dotsMenu = ['Print', 'Export'];
        return (
            <ErrorBoundary className="manage-report-certifications" data-cy="certificationsShowcase">
                <Filter onChange={this.handleFilter} />
                <div className="card">
                    <div className="d-flex align-items-center mb-3 pt-1 pt-md-2">
                        <div className="dsl-b22 text-500 d-flex-1">{title}</div>
                        <DatePicker calendar="range" append="caret" format="MMM D" align="right" as="span" value={date} onSelect={this.handleDate} />
                        <EditDropdown className="ml-3" options={dotsMenu} onChange={this.handleSelectMenu} />
                    </div>
                    <Tabs id="certifications" defaultActiveKey="employees" activeKey={activeTab} onSelect={this.handleSelectTab}>
                        <Tab key="employees" eventKey="employees" title="Employees">
                            <EmployeesReport role={userRole} data={users} navigate={this.props.navigate} location={this.props.location} onClick={this.handleOpenCertification} />
                        </Tab>
                        <Tab data-cy="certificationsList" key="certifications" eventKey="certifications" title="Certifications">
                            <CertReport role={userRole} data={programs} onClick={this.handleOpenCertification} />
                        </Tab>
                    </Tabs>
                    {users.length >= per && <Pagination current={page} total={last_page} onChange={this.handlePage} onPer={this.handlePer} />}
                </div>
            </ErrorBoundary>
        );
    }
}

Certifications.propTypes = {
    company: PropTypes.array,
    certificationsReport: PropTypes.shape({
        type: PropTypes.string,
        users: PropTypes.array,
        programs: PropTypes.array,
        page: PropTypes.number,
        per_page: PropTypes.number,
        last_page: PropTypes.number,
    }),
    getCertifications: PropTypes.func,
    getProgramDetail: PropTypes.func,
    toggleModal: PropTypes.func,
};

Certifications.defaultProps = {
    company: [],
    certificationsReport: {
        type: 'employees',
        users: [],
        programs: [],
        page: 1,
        per_page: 25,
        last_page: 1,
        total: 1,
    },
    getCertifications: () => {},
    getProgramDetail: () => {},
    toggleModal: () => {},
};

const mapStateToProps = (state) => ({
    company: state.app.selectedCompany,
    userRole: state.app.app_role_id,
    companies: state.app.companies,
    certificationsReport: state.manage.certificationsReport,
});

const mapDispatchToProps = (dispatch) => ({
    getCertifications: (target, payload) => dispatch(ManageActions.fetchcertificationsreportRequest(target, payload)),
    getProgramDetail: (payload, type, route) => dispatch(DevelopActions.libraryprogramdetailRequest(payload, type, route)),
    deleteProgram: (e) => dispatch(DevelopActions.programeventRequest(e)),
    toggleModal: (e) => dispatch(AppActions.modalRequest(e)),
});

const CertificationsWithNavigate = withNavigate(Certifications);

export default connect(mapStateToProps, mapDispatchToProps)(CertificationsWithNavigate);
